// var $ = require("?jQuery");
// require("?jQuery.dataTable");
// for export buttons:
// require("?jszip.min");
// require("?dataTables.buttons.min");
// require("?buttons.html5.min");
// require("?buttons.flash.min");
var getData = require('../GetData/GetData').GetData;
var getMeta = require('../GetMeta/GetMeta').GetMeta;

var extractStructure = function(meta, data) {
    var jsonString = JSON.stringify(meta.table.headers);
    var jsonMeta = JSON.parse(jsonString);

    var tableHeader = [];

    if (jsonMeta === "false") {

        // 1. STEP: get data from URL or embedded
        var jsonDataMeta = getMeta(data);

        for (var j = 0; j < jsonDataMeta.length; j++) {
            var text2 = {
                'title': jsonDataMeta[j].key,
                'sortable': false,
                'searchable': true
            };
            tableHeader.push(text2);
        }

        return tableHeader;
    } else {

        for (var i = 0; i < jsonMeta.length; i++) {
            var text = {
                'title': jsonMeta[i].text,
                'sortable': jsonMeta[i].sortable,
                'searchable': jsonMeta[i].searchable
            };
            tableHeader.push(text);
        }

        return tableHeader;
    }
};

function isObjectEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
var extractData = function(meta, data) {

    // 1. STEP: get data from URL or embedded
    var jsonData = getData(data);

    var jsonStringMeta = JSON.stringify(meta.table.headers);
    var jsonMeta = JSON.parse(jsonStringMeta);

    // 2. STEP: Built table body from processed Data
    var tableBody = [];
    if (jsonMeta === "false") {

        // Get meta from table headers:
        var tableHeader = [];
        var jsonDataMeta = data.embedded.meta;

        for (var j = 0; j < jsonDataMeta.length; j++) {
            var text2 = {
                'key': jsonDataMeta[j].key
            };
            tableHeader.push(text2);
        }

        // Process Data from jsonData
        //
        //
        var processedData = [];

        for (var i = 0; i < jsonData.length; i++) {
            var obj = jsonData[i];
            var p = {};

            //console.log('Obj:', obj);

            for (var key in obj) {
                var attrName = key;

                //console.log('tableHeader', tableHeader);
                for (var j = 0; j < tableHeader.length; j++) {
                    var obj1 = tableHeader[j];

                    //console.log('Obj1:', obj1);

                    for (var key in obj1) {

                        //console.log('Key:', key);

                        if (key == "key") {
                            var attrValue = obj1[key];

                            //console.log('attrValue:', attrValue);
                            if (attrName == attrValue) {
                                p[attrValue] = obj[attrName];
                            }

                            if (typeof p[attrValue] == "undefined") {
                                p[attrValue] = "";
                            }
                        }
                    }
                }
            }

            if (!isObjectEmpty(p)) {
                processedData.push(p);
            }
        }

        //console.log('processedData:', processedData);

        for (var i = 0; i < processedData.length; i++) {

            var jsonStringRow = JSON.stringify(processedData[i]);
            var tableRowData = JSON.parse(jsonStringRow);

            var tableRow = [];
            for (var key in tableRowData) {
                var rowArray = tableRowData[key];
                tableRow.push(rowArray);
            }

            tableBody.push(tableRow);
        }
        //console.log('This is Data for table body:', tableBody);
        return tableBody;
    } else {
        // Process Data from inserted Meta
        //
        //
        var processedData = [];

        for (var i = 0; i < jsonData.length; i++) {
            var obj = jsonData[i];
            var p = {};

            //console.log('Obj:', obj);

            for (var key in obj) {
                var attrName = key;

                //console.log('jsonMeta', jsonMeta);
                for (var j = 0; j < jsonMeta.length; j++) {
                    var obj1 = jsonMeta[j];

                    //console.log('Obj1:', obj1);

                    for (var key in obj1) {

                        //console.log('Key:', key);

                        if (key == "key") {
                            var attrValue = obj1[key];

                            //console.log('attrValue:', attrValue);
                            if (attrName == attrValue) {
                                p[attrValue] = obj[attrName];
                            }

                            if (typeof p[attrValue] == "undefined") {
                                p[attrValue] = "";
                            }
                        }
                    }
                }
            }

            if (!isObjectEmpty(p)) {
                processedData.push(p);
            }
        }

        //console.log('This is processedData:', processedData);

        for (var i = 0; i < processedData.length; i++) {

            var jsonStringRow = JSON.stringify(processedData[i]);
            var tableRowData = JSON.parse(jsonStringRow);

            var tableRow = [];
            for (var key in tableRowData) {
                var rowArray = tableRowData[key];
                tableRow.push(rowArray);
            }

            tableBody.push(tableRow);
        }

        //console.log('This is Data for table body:', tableBody);
        return tableBody;
    }
};

var render = function(htmlElement, dataType, tableStructure, tableData) {
    var table = document.createElement('table');

    var modWidth = 50;

    // Liferay localization
    var language;
    var text1;
    var title1;
    var text2;
    var title2;
    if ( Liferay.ThemeDisplay.getLanguageId() == "sl_SI" ) {
        language = {
          	"sEmptyTable": "Nobenih podatkov ni na voljo",
          	"sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
          	"sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
          	"sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
          	"sInfoPostFix": "",
          	"sInfoThousands": ",",
          	"sLengthMenu": "Prikaži _MENU_ zapisov",
          	"sLoadingRecords": "Nalagam...",
          	"sProcessing": "Obdelujem...",
          	"sSearch": "Išči tabelo:",
          	"sZeroRecords": "Nobeden zapis ne ustreza",
          	"oPaginate": {
            		"sFirst": "Prvi",
            		"sLast": "Zadnji",
            		"sNext": "Nasl.",
            		"sPrevious": "Pred."
          	},
          	"oAria": {
            		"sSortAscending": ": vključite za naraščajoči sort",
            		"sSortDescending": ": vključite za padajoči sort"
          	}
        };
        text1 = 'Izvozi v CSV';
        title1 = 'CSV izvoz';
        text2 = 'Izvozi v Excel';
        title2 = 'Excel izvoz';
    } else {
        language = void 0;
        text1 = 'Export to CSV';
        title1 = 'CSV export';
        text2 = 'Export to Excel';
        title2 = 'Excel export';
    }

    $(htmlElement).append(table);
    $(table).DataTable({
        data: tableData,
        columns: tableStructure,
        language: language,
        dom: 'Bfrtip',
        buttons: [{
            extend: 'csv',
            text: text1,
            title: title1,
            fieldSeparator: ';',
            footer: false,
            exportOptions: {
                orthogonal: 'filter',
            }
        }, {
            extend: 'excel',
            text: text2,
            title: title2,
            exportOptions: {
                columns: ':visible',
            }
        }]
    });
    $(table).addClass("table table-condenseds");
    $(table).width("100%");
}

module.exports = {
    extractStructure: extractStructure,
    extractData: extractData,
    render: render
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/DataTable/DataTable.js
// module id = 3
// module chunks = 0